export default __webpack_public_path__ + "static/media/HechterTailored.33c411e9.jpeg";